import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { buildApiUrl } from "../utils/api";

function ClientRegister() {
    const [formData, setFormData] = useState({ name: '', email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(buildApiUrl('/api/client/register'), formData);
            localStorage.setItem('token', response.data.token);
            // Redirect to dashboard or quotes page
            navigate('/clientDetails');
        } catch (error) {
            console.error('Error registering user', error);
        }
    };

    return (
        <div className='registerUser'>
            <h1 className='text-start'>Are you a New Client?</h1>
            <div className='container form-detail d-flex justify-content-center align-items-center'>
                <form onSubmit={handleSubmit} >
                    <h3 style={{color:"#fff", fontWeight:"bold"}}>Register Now</h3>
                    <input type="text" name="name" placeholder="Name" onChange={handleChange} required />
                    <input type="email" name="email" placeholder="Email" onChange={handleChange} required />
                    <input type="text" name="warehouseName" placeholder="Warehouse Name" onChange={handleChange} required />
                    <input type="text" name="warehouseLocation" placeholder="Warehouse Location" onChange={handleChange} required />
                    <input type={showPassword ? "text" : "password"} name="password" placeholder="Password" onChange={handleChange} required />
                    <div className="d-flex align-items-center">
                        <input
                            type="checkbox"
                            id="showPassword"
                            onClick={() => setShowPassword(!showPassword)}
                        />
                        <label htmlFor="showPassword" className="ms-2" style={{ fontWeight: "bold" }}>
                            {showPassword ? "Hide Password" : "Show Password"}
                        </label>
                    </div>
                    <button type="submit">Register Now</button>
                    <div className='returnHome'>
                        <Link to='/' style={{ textDecoration: "none", color: "#fff" }}><p>Go to Home Page</p></Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ClientRegister;
